import React, { Component } from "react";
import Information from "../information/Information";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { Paths } from "../../constants/UrlConstants";
import { downloadMedicalConsent } from "../../actions/medicalConsent/medicalConsentActions";
import { connect } from "react-redux";
import Button from "../shared/buttons/Button";
import { withRouter } from "react-router-dom";
import InfoBox from "../../components/shared/InfoBox";
import styles from "../../assets/css/modules/medicalconsent/medicalconsentconfirmation.css";
import { API_ROOT } from "../../api-config";
import FileDownload from "../download/FileDownload";

const mapDispatchToProps = (dispatch) => {
  return { downloadMedicalConsent: () => dispatch(downloadMedicalConsent()) };
};

class MedicalConsentConfirmation extends Component {
  static pdfPostFix = ".pdf";
  constructor(props) {
    super(props);

    const currentDate = new Date();
    this.state = {
      medicalConsentFileName:
        "Consent for " +
        this.props.claimNumber +
        " - " +
        currentDate.getDate() +
        "." +
        (currentDate.getMonth() + 1) +
        "." +
        currentDate.getFullYear()
    };
    this.handleBackToClaims = this.handleBackToClaims.bind(this);
  }

  handleBackToClaims() {
    this.props.history.push(Paths.Claims);
  }

  render() {
    return (
      <div className="medical-consent">
        <Information
          headerText={Store.MedicalConsent.MedicalConsentConfirmation.Header}
        >
          <Content
            name={Store.MedicalConsent.MedicalConsentConfirmation.Body}
          />
          <p>
            <FileDownload
              name="downloadFile"
              url={`${API_ROOT}/medicalconsent`}
              fileName={this.state.medicalConsentFileName}
            >
              <i className="icon-document" />
              {this.state.medicalConsentFileName}
            </FileDownload>
          </p>
          <InfoBox
            iconClass={"icon-functional-help"}
            className={styles.infoBoxOverride}
          >
            <strong>Please note:</strong>
            <ul>
              <li>
                <Content
                  name={
                    Store.MedicalConsent.MedicalConsentConfirmation.BodyNote1
                  }
                />
              </li>
              <li>
                <Content
                  name={
                    Store.MedicalConsent.MedicalConsentConfirmation.BodyNote2
                  }
                />{" "}
                {this.props.claimNumber}
              </li>
            </ul>
          </InfoBox>
          <br />

          <Button
            onClick={this.handleBackToClaims}
            label={
              Store.MedicalConsent.MedicalConsentConfirmation.BackButtonText
            }
          />
        </Information>
      </div>
    );
  }
}

export default withRouter(
  connect(null, mapDispatchToProps)(MedicalConsentConfirmation)
);
